import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import SuggestionWidget from "./components/SuggestionWidget/SuggestionWidget.jsx";

export function renderSuggestionWidget(configuration) {
  const containerId = configuration.container || "suggestions-widget-container";
  const container = document.getElementById(containerId);
  if (!container) return;

  const root = createRoot(container);
  root.render(
    <div className="suggestions_widget-container">
      <SuggestionWidget config={configuration} />
    </div>
  );
}

document.addEventListener("DOMContentLoaded", function () {
  const configElements = document.querySelectorAll(".suggestions-widget-config");
  if (configElements.length > 0) {
    for (const configElement of configElements) {
      renderSuggestionWidget(JSON.parse(configElement.innerText));
    }
    return;
  }

  // Backward compatibility with legacy single-widget markup.
  const legacyConfig = document.getElementById("suggestions-widget-config");
  if (legacyConfig) {
    renderSuggestionWidget(JSON.parse(legacyConfig.innerText));
  }
});
